// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2BeTH","sendOtp":"AuthorizeToLogin_sendOtp__2Q5Xh"};